/**
 * SlideTransformPanel.tsx — the routed home for Transform Slide.
 *
 * Reached from the Deckorate home grid and the command palette, whereas the
 * chat chip opens the same feature in the chat column. Both surfaces render the
 * SAME {@link TransformChatFlow}: the mockup runs Transform Slide entirely as a
 * conversation (mode question → progress → result, with action pills), and
 * having the panel re-implement that in a second, slightly different shape is
 * how the two drift apart.
 *
 * So this is deliberately thin — a module header for the routed entry point,
 * with the flow itself underneath. All of the behaviour lives in the flow and
 * the two hooks behind it.
 */

import { ModuleHeader } from "../../../../../shared/components/ModuleHeader";
import { TransformChatFlow } from "./TransformChatFlow";
import styles from "./SlideTransformPanel.module.css";

interface SlideTransformPanelProps {
  readonly onBack?: () => void;
}

export function SlideTransformPanel({ onBack }: Readonly<SlideTransformPanelProps>) {
  return (
    <div className={styles.panel}>
      <ModuleHeader title="Transform Slide" subtitle="Deckorate" onBack={onBack} />

      {/* The flow's "Close" pill returns to wherever the panel was opened from,
          which is this surface's equivalent of dismissing the conversation. */}
      <TransformChatFlow variant="panel" onClose={() => onBack?.()} />
    </div>
  );
}
